/*
高春超 2018年3月9日20:17:41
*/
<template>
  <div class="conInner">
    <section id="content_wrapper">
      <div class="data">
        <h2>我的积分</h2>
      </div>
      <div class="tip">
        <div class="top"></div>
        <div class="body">
          <img src="//static.kxymall.com/images/gth.jpg">
          <div>
            <b>积分规则:</b>
            <ol>
              <li>当积分已达到某一兑换积分标准时，顾客可将累计积分依照网站相应积分及兑换标准兑换回馈商品，网站将即时从用户会员积分中扣减相应积分。</li>
              <li>各项回馈项目（包含各项商品、服务或抵用券等）及兑换标准及兑换规则均以兑换当时最新回馈活动公告或目录为准。</li>
              <li>部分兑换商品有数量限制的，兑完为止。</li>
              <li>公告或目录如有有效期限的，逾期即不得兑换。</li>
              <li>积分兑换区的商品为只可用积分兑换的商品(如积分价格：100积分)</li>
            </ol>
          </div>
        </div>
        <div class="bottom"></div>
      </div>
      <div class="tab">
        <ul>
          <li :class="tabIndex===tab.idx?'selected':''" v-for="tab in tabItem" @click="changeTabItem(tab.idx)">
            <a><span>{{tab.name}}</span></a>
          </li>
        </ul>
      </div>
      <div class="point_wrap white_box">
        <div class="box">
          <div class="top" :style="tabIndex===0?pointBg:tableBg"></div>
          <div class="body">
            <div class="pointsSumm" v-show="tabIndex===0">
              <h4>消费积分</h4>
              <div class="overview">
                <p class="layerCol">
                  可用积分：<strong>{{costPoint}}</strong>
                  冻结积分：<strong>{{freezePoint}}</strong>
                </p>
              </div>
            </div>
            <div v-show="tabIndex===1">
              <Table class="order-table" :columns="point.column" :data="point.list" no-data-text="尚无积分"></Table>
              <Page :total="point.total" show-total show-elevator @on-change="changePointPage"
                :current="point.pageIndex" style="float:right;margin-top:10px;" :page-size="pageSize"></Page>
            </div>
            <div v-show="tabIndex===2">
              <Table class="order-table" :columns="freeze.column" :data="freeze.list" no-data-text="尚无冻结积分"></Table>
              <Page :total="freeze.total" show-total show-elevator @on-change="changeFreezePage"
                :current="freeze.pageIndex" style="float:right;margin-top:10px;" :page-size="pageSize"></Page>
            </div>
          </div>
          <div class="bottom"></div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { getUserStat, pointList, pointFreezeList } from 'api/user';
import { parseTime } from 'utils/tool';
export default {
  data() {
    return {
      tabIndex: 0,
      pointBg: {
        'background': 'url(//static.kxymall.com/images/hybs.jpg) no-repeat left top'
      },
      tableBg: {
        'background': 'url(//static.kxymall.com/images/hylyt.jpg) no-repeat left top'
      }
      ,
      tabItem: [{
        idx: 0,
        name: '我的积分'
      }, {
        idx: 1,
        name: '积分明细'
      }, {
        idx: 2,
        name: '冻结明细'
      }],
      point: {
        column: [{
          title: '时间',
          align: 'center',
          key: 'time',
          render: (h, params) => {
            return parseTime(params.row.time);
          }
        }, {
          title: '明细',
          align: 'center',
          key: 'reason'
        }, {
          title: '等级积分',
          align: 'center',
          width: 130,
          key: 'point'
        }, {
          title: '消费积分',
          align: 'center',
          width: 130,
          key: 'mp'
        }],
        list: [],
        pageIndex: 1,
        total: 0
      }
      ,
      freeze: {
        column: [{
          title: '时间',
          align: 'center',
          key: 'dateline',
          render: (h, params) => {
            return parseTime(params.row.dateline);
          }
        }, {
          title: '明细',
          align: 'center',
          key: 'type',
          render: (h, params) => {
            let type = '';
            switch (params.row.type) {
              case "order_pay_use":
                type = '订单消费积分';
                break;
              case "order_pay_get":
                type = '订单获得积分';
                break;
              case "register":
                type = '注册';
                break;
              case "email_check":
                type = '邮箱验证';
                break;
              case "finish_profile":
                type = '完善个人资料';
                break;
              case "buygoods":
                type = '购买商品';
                break;
              case "onlinepay":
                type = '在线支付';
                break;
              case "operator_adjust":
                type = '管理员改变积分';
                break;
              case "consume_gift":
                type = '积分换赠品';
                break;
              case "login":
                type = '登录';
                break;
              case "comment":
                type = '发表评价';
                break;
              case "comment_img":
                type = '贴图评价';
                break;
              case "first_comment":
                type = '首次评论';
                break;
              case "register_link":
                type = '推广连接';
                break;
            }
            return type;
          }
        }, {
          title: '等级积分',
          align: 'center',
          width: 130,
          key: 'point'
        }, {
          title: '消费积分',
          align: 'center',
          width: 130,
          key: 'mp'
        }, {
          title: '状态',
          align: 'center',
          width: 100,
          render: h => {
            return '冻结'
          }
        }],
        list: [],
        pageIndex: 1,
        total: 0
      }
      ,
      pageSize: 20,
      costPoint: 0,
      freezePoint: 0
    }
  },
  created() {
    this.getMyPointData();
  },
  methods: {
    // 切换Tab
    changeTabItem(idx) {
      this.tabIndex = idx;
      switch (idx) {
        case 0:
          this.getMyPointData();
          break;
        case 1:
          this.getPointList();
          break;
        case 2:
          this.getFreezeList();
          break;
      }
    },
    // 获取可用积分列表
    getPointList() {
      pointList({
        page: this.point.pageIndex,
        pageSize: this.pageSize
      }).then(resp => {
        if (resp.resCode === 1) {
          this.point.total = resp.data.total;
          this.point.list = resp.data.list;
        } else {
          this.point.total = 0;
          this.point.list = [];
        }
      })
    },
    // 获取冻结积分列表
    getFreezeList() {
      pointFreezeList({
        page: this.freeze.pageIndex,
        pageSize: this.pageSize
      }).then(resp => {
        console.log(resp)
        if (resp.resCode === 1) {
          this.freeze.total = resp.data.total;
          this.freeze.list = resp.data.list;
        } else {
          this.freeze.total = 0;
          this.freeze.list = [];
        }
      })
    },
    // 我的积分翻页
    changePointPage(page) {
      this.point.pageIndex = page;
      this.getPointList();
    },
    // 冻结积分翻页
    changeFreezePage(page) {
      this.freeze.pageIndex = page;
      this.getFreezeList();
    },
    // 获取统计数据
    getMyPointData: function () {
      getUserStat().then(resp => {
        if (resp.resCode === 1) {
          this.freezePoint = resp.data.freezePoint;
          this.costPoint = resp.data.costPoint;
        }
      });
    }
  }
}
</script>

<style scoped>
.ivu-table-wrapper {
  border: none !important;
}

.ivu-table:before {
  content: "";
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// point.vue?33f0384e